import avatarDefault from "../../assets/img/avatarDefault.png"
import { TbDotsVertical } from "react-icons/tb";
import { atualizarEtapaController, excluirEtapaController, listarProjetoPorId } from "../../services/projetos";
import { listarBacklogController } from "../../services/backlog";
import { FormEvent, useContext, useEffect, useState, DragEvent } from "react";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { criptografarDado } from "../../helpers";
import { EtapaProjeto, listarProjeto, MembroProjeto, TarefasProjeto } from "../../interfaces/projetos";
import { BacklogParaTarefa, paramsListarBacklogs } from "../../interfaces/backlog";
import ModalEtapaProjetos from "../ModalEtapaProjetos";
import { Button } from "../Styles";
import { ModalEstadoContext } from "../../contexts/ModalEstado";
import ModalTarefas from "../ModalTarefas";
import ModalBacklog from "../ModalBacklog";
import TarefaCard from "../TarefaCard";
import { atualizarTarefa } from "../../services/tasks";
import ModalDocumentosProjeto from "../ModalDocumentosProjetos";
import "./index.css"
import ModalTarefaNovaEtapa from "../ModalTarefaNovaEtapa";

function QuadrosKanban() {
  const { atualizarDados, modal, modalExibir, atualizarInformacoes } = useContext(ModalEstadoContext)
  const { search, pathname } = useLocation()
  const navigate = useNavigate();

  const paramsUrl = new URLSearchParams(search)

  const idProjeto = paramsUrl.get("idProjeto");
  const grupo = paramsUrl.get("grupo");
  const tarefasConcluida = paramsUrl.get("tarefaConcluida") === "true";

  const usuarioExterno = localStorage.getItem("usuarioProjeto")

  const [projetos, setProjetos] = useState<listarProjeto>();
  const [etapa, setEtapa] = useState<EtapaProjeto>();

  const [menuAberto, setMenuAberto] = useState<number | null>(null)
  const [backlogs, setBacklogs] = useState<paramsListarBacklogs[]>([])

  const [idEtapaSelecionado, setIdEtapaSelecionado] = useState<number>()

  const [tarefaSelecionada, setTarefaSelecionada] = useState<TarefasProjeto>();

  const [projetosEtapas, setProjetosEtapas] = useState<EtapaProjeto[]>([]);

  const [backlogParaTarefa, setBacklogParaTarefa] = useState<BacklogParaTarefa>();

  const abrirModalEtapa = (etapa?: EtapaProjeto) => {
    setEtapa(etapa);
    modalExibir("ModalEtapaProjeto");
  };

  const excluirEtapa = async (e: FormEvent, idEtapa: string) => {
    e.preventDefault()
    try {
      const idEtapaCript = criptografarDado(idEtapa)
      const resposta = await excluirEtapaController(idEtapaCript)

      if (resposta.status === 200) {
        toast.success("Etapa Excluida com Sucesso.")
        atualizarDados()
      }
    } catch (error) {
      toast.error("Erro ao Excluir Etapa")
    }
  }

  const abrirMenuDropDownEtapa = (idEtapa: number) => {
    if (menuAberto === idEtapa) {
      setMenuAberto(null);
    } else {
      setMenuAberto(idEtapa);
    }
  }

  const abrirModalNovaTarefa = (idEtapa: number) => {
    setIdEtapaSelecionado(idEtapa)
    setTarefaSelecionada(undefined)
    modalExibir("ModalTarefaProjeto")
  }

  const abrirModalEditarTarefa = (tarefa: TarefasProjeto) => {
    setTarefaSelecionada(tarefa)
    modalExibir("ModalTarefaProjeto")
  }

  const abrirModalTarefaNovaEtapa = (tarefa: TarefasProjeto, idEtapa: number) => {
    setTarefaSelecionada(tarefa)
    setIdEtapaSelecionado(idEtapa)
    modalExibir("ModalTarefaNovaEtapa")
  }

  const toggleTarefasConcluidas = () => {
    const newSearchParams = new URLSearchParams(paramsUrl);
    if (tarefasConcluida) {
      newSearchParams.delete("tarefaConcluida");
    } else {
      newSearchParams.set("tarefaConcluida", "true");
    }
    navigate(`${pathname}?${newSearchParams.toString()}`, { replace: true });
  };

  const dropTarefa = async (e: DragEvent<HTMLDivElement>, etapa: EtapaProjeto) => {
    e.preventDefault()
    if (usuarioExterno) return;
    setTarefaSelecionada(undefined)

    const tarefa = e.dataTransfer.getData("tarefa")
    if (tarefaSelecionada?.idEtapa && tarefaSelecionada.idEtapa.toString() === etapa.id.toString()) return;
    try {
      const backlogArrastado = backlogs.find((b) => b.id.toString() === tarefa)

      if (backlogArrastado && projetos) {
        setBacklogParaTarefa({ id: backlogArrastado.id, titulo: backlogArrastado.titulo, descricao: backlogArrastado.ideia })
        abrirModalNovaTarefa(etapa.id);
        return;
      }

      if (etapa.etapa === "Backlog") {
        toast.info("Não é permitido transformar a Tarefa em Backlog.")
        return;
      }

      if (!tarefaSelecionada) return toast.info("Tarefa não encontrada.")

      return abrirModalTarefaNovaEtapa(tarefaSelecionada, etapa.id)

    } catch (error) {
      return toast.error("Erro ao Arrastar Tarefa.")
    }
  }

  const atualizarEtapaTarefa = async (idTarefa: string, idEtapa: number) => {
    try {
      if (usuarioExterno) return;
      setTarefaSelecionada(undefined)
      const payload = {
        idEtapa
      }

      const resposta = await atualizarTarefa(idTarefa, payload)

      if (resposta.status === 200) {
        atualizarDados()
        return;
      };
    } catch (error) {
      return toast.error("Erro ao Atualizar Etapa da Tarefa")
    }
  }

  const dropEtapa = async (e: DragEvent<HTMLDivElement>, etapa: EtapaProjeto, index: number) => {
    e.preventDefault()
    if (usuarioExterno) return;
    const idEtapaArrastada = e.dataTransfer.getData("idEtapaArrastada");
    if (!idEtapaArrastada) return;

    if (idEtapaArrastada === etapa.id.toString()) return;
    if (!idProjeto) return toast.error("Projeto não encontrado.")
    try {
      const idEtapaCript = criptografarDado(idEtapaArrastada)
      const idProjetoCript = idProjeto.toString()

      const payload = {
        ordem: index,
        idProjeto: idProjetoCript
      }

      const resposta = await atualizarEtapaController(idEtapaCript, payload)

      if (resposta.status === 200) {
        atualizarDados()
        return;
      };

    } catch (error) {
      return toast.error("Erro ao Arrastar Tarefa.")
    }
  }

  const dragOverTarefa = (e: DragEvent<HTMLDivElement>) => {
    if (usuarioExterno) return;
    e.preventDefault()
  }

  const dragOverEtapa = (e: DragEvent<HTMLDivElement>) => {
    if (usuarioExterno) return;
    e.preventDefault()
  }

  useEffect(() => {
    const listarProjeto = async () => {
      if (!idProjeto) return toast.error("Não foi possivel encontrar o projeto.")

      try {

        const resposta = await listarProjetoPorId(idProjeto);

        setProjetos(resposta.data);

        const etapas = resposta.data.projetosEtapas || [];

        if (tarefasConcluida) {
          return setProjetosEtapas(resposta.data.projetosEtapas)
        } else {
          const etapasFiltradas = etapas.map((etapa: EtapaProjeto) => {
            const tarefasFiltradas = etapa.tarefas?.filter((tarefa: TarefasProjeto) => tarefa.situacao !== "concluída") || [];
            return { ...etapa, tarefas: tarefasFiltradas };
          });

          return setProjetosEtapas(etapasFiltradas)
        }
      } catch (error) {
        return toast.error("Erro ao listar todos os projeto.");
      }
    };

    listarProjeto()
  }, [atualizarInformacoes, idProjeto, tarefasConcluida])

  useEffect(() => {
    const listarBacklogs = async () => {
      if (!idProjeto) return toast.error("Não foi possivel encontrar o projeto.")
      try {
        const resposta = await listarBacklogController(idProjeto)

        if (resposta.status === 200 && tarefasConcluida) {
          setBacklogs(resposta.data);
        } else {
          const backlogsFiltrados = resposta.data.filter((backlog: any) => backlog.situacao === "Pendente");
          setBacklogs(backlogsFiltrados);
        }
      } catch (error) {
        return toast.error("Erro ao listar os Backlogs")
      }
    }
    listarBacklogs()
  }, [atualizarInformacoes, idProjeto, tarefasConcluida])

  return (
    (grupo === "Desenvolvimento de Software" || grupo === "Outros") ? (
      <div className="paginaContainer">
        <div className="kanban-header">
          <div className="kanban-header-content">
            <div className="kanban-grid kanban-grid-mobile">
              <div>
                <h2 className="kanban-project-title">{projetos?.titulo}</h2>
                <p className="kanban-client-name">Cliente: {projetos?.cadastro.nomeFantasia}</p>
                <p className="kanban-group">Grupo: {projetos?.grupo}</p>
              </div>
              <div>
                <h2 className="kanban-section-title">Descrição do Projeto</h2>
                <p className="kanban-description">{projetos?.descricao}</p>
              </div>
              <div>
                <h2 className="kanban-section-title">Membros do Projeto</h2>
                <div className="kanban-members">
                  <div className="kanban-member-avatar-space">
                    {projetos?.projetosMembros.slice(0, 3).map((membro: MembroProjeto, index) => (
                      <div className={`kanban-members-avatar`} style={{ zIndex: index * 10, left: - 15 * index }} key={index} title={membro.usuario.nome}>
                        <img src={membro.usuario.avatar ? membro.usuario.avatar : avatarDefault} alt="" />
                      </div>
                    ))}
                  </div>
                </div>
                <div className="kanban-checkbox-container">
                  <input
                    checked={tarefasConcluida}
                    className="toggleAutomacaoTarefas"
                    id="toggleTarefasConcluidas"
                    type="checkbox"
                    onChange={toggleTarefasConcluidas} />
                  <label className="label-toggleAutomacaoTarefas" htmlFor="toggleTarefasConcluidas"></label>
                  <p>Tarefas Concluídas</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="kanban-btn">
          <Button type="button" cor="filtros" isLoading={false} onClick={() => { modalExibir("ModalDocumentosProjeto") }}>
            Documentos
          </Button>
          {!usuarioExterno && <Button type="button" cor="filtros" isLoading={false} onClick={() => { abrirModalEtapa() }}>
            Adicionar Etapa
          </Button>}
        </div>
        <div className="kanban-steps-container">
          <div className="kanban-steps">
            {projetosEtapas.sort((a, b) => a.ordem - b.ordem).map((etapa: EtapaProjeto, index) => (
              <div className="kanban-step" key={etapa.id}>
                <div className="kanban-step-header" onDrop={(e) => dropEtapa(e, etapa, index)} onDragStart={(e) => {
                  e.dataTransfer.setData("idEtapaArrastada", etapa.id.toString());
                }} onDragOver={(e) => dragOverEtapa(e)} draggable>
                  <h3 className="kanban-step-title">{etapa.etapa}</h3>
                  {!usuarioExterno && <button className="kanban-step-dropdown-button" onClick={() => abrirMenuDropDownEtapa(etapa.id)}>
                    <TbDotsVertical />
                    {menuAberto === etapa.id && (
                      <div className="kanban-step-dropdown-menu">
                        <ul>
                          <li className="kanban-dropdown-item" onClick={() => abrirModalEtapa(etapa)}>
                            Editar Etapa
                          </li>
                          <li className="kanban-dropdown-item" onClick={(e) => excluirEtapa(e, etapa.id.toString())}>
                            Excluir Etapa
                          </li>
                        </ul>
                      </div>
                    )}
                  </button>}
                </div>
                {!usuarioExterno && etapa.etapa === "Backlog" &&
                  <button className="kanban-step-add-backlog" onClick={() => modalExibir("ModalBacklog")}>
                    <span className="mr-1">+</span> Novo Backlog
                  </button>
                }
                {!usuarioExterno && etapa.etapa !== "Backlog" &&
                  <button className="kanban-step-add-task" onClick={() => abrirModalNovaTarefa(etapa.id)}>
                    <span className="mr-1">+</span> Nova Tarefa
                  </button>
                }
                <div className="kanban-step-task-list" onDrop={(e) => dropTarefa(e, etapa)} onDragOver={(e) => dragOverTarefa(e)}>
                  {etapa.etapa === "Backlog" && backlogs.map((backlog) => (
                    <TarefaCard id={backlog.id} titulo={backlog.titulo} ideia={backlog.ideia} situacao={backlog.situacao} key={backlog.id} />
                  ))}
                  {etapa.tarefas.map((tarefa) => (
                    <TarefaCard tarefa={tarefa} id={tarefa.id.toString()} titulo={tarefa.titulo} ideia={tarefa.ideia} situacao={tarefa.situacao} key={tarefa.id} abrirModalEditarTarefa={abrirModalEditarTarefa} setTarefaSelecionada={setTarefaSelecionada} />
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
        {modal.nome === "ModalEtapaProjeto" && <ModalEtapaProjetos etapa={etapa || null} />}
        {modal.nome === "ModalTarefaProjeto" && <ModalTarefas tarefa={tarefaSelecionada} backlog={backlogParaTarefa} idEtapa={idEtapaSelecionado} />}
        {modal.nome === "ModalBacklog" && idProjeto && <ModalBacklog />}
        {modal.nome === "ModalDocumentosProjeto" && idProjeto && <ModalDocumentosProjeto />}
        {modal.nome === "ModalTarefaNovaEtapa" && tarefaSelecionada && idEtapaSelecionado && <ModalTarefaNovaEtapa tarefaSelecionada={tarefaSelecionada} idEtapaSelecionado={idEtapaSelecionado} atualizarEtapaTarefa={atualizarEtapaTarefa} />}
      </div>
    ) : null
  );
}

export default QuadrosKanban